import { useRouteError } from "react-router-dom";
import { Link } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page" className="flex flex-col items-center justify-center min-h-screen bg-secondary text-text-primary px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold mb-4 text-primary">Oops!</h1>
        <p className="text-xl mb-4">Sorry, an unexpected error has occurred.</p>
        <p className="text-lg mb-8">
          <i>{error.statusText || error.message}</i>
        </p>
        <Link to="/" className="bg-accent text-text-primary px-6 py-3 rounded-md shadow-md hover:bg-accent transition-colors">
          Go Back Home
        </Link>
      </div>
    </div>
  );
}
